/**
 * Event Service
 * Historical events service API: a read-only record of what happened inside a Convercus loyalty program. It serves the stored event history for accounts, memberships and users, for coupons, for news posts and for workflows, filtered by subject, date range, originating user and event type. Every endpoint is a paginated read; the service never writes, edits or replays events.
 *
 * The version of the OpenAPI document: v1.0.37758
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { AccountUserEventResponse } from '../model/models';
import { NormalizedAccountEventDtoResponse } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {
    AccountsServiceInterface,
    ListAccountEventsRequestParams,
    ListNormalizedEventsRequestParams
} from './accounts.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class AccountsService implements AccountsServiceInterface {

    protected basePath = 'https://staging.convercus.io';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * List account and user events
     * Deprecated: use GET /v2/events/account-user (listNormalizedEvents) instead, which serves the same history with a unified event shape. This version remains available and unchanged. Returns the recorded account, membership and user event history for the calling program, narrowed by any combination of accountId, userId and membershipId; at least one of the three is required. Each entry keeps the shape its event type was stored with, so the result list is a union of the twelve account-user event schemas rather than one common shape. Differences to be aware of before migrating: v2 ignores orderBy and order and always sorts by createdAt descending, and it returns one normalized document shape rather than the union of twelve typed schemas.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public listAccountEvents(requestParameters: ListAccountEventsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<AccountUserEventResponse>;
    public listAccountEvents(requestParameters: ListAccountEventsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<AccountUserEventResponse>>;
    public listAccountEvents(requestParameters: ListAccountEventsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<AccountUserEventResponse>>;
    public listAccountEvents(requestParameters: ListAccountEventsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const program = requestParameters.program;
        if (program === null || program === undefined) {
            throw new Error('Required parameter program was null or undefined when calling listAccountEvents.');
        }
        const createdByUsername = requestParameters.createdByUsername;
        const createdByUserId = requestParameters.createdByUserId;
        const fromDate = requestParameters.fromDate;
        const toDate = requestParameters.toDate;
        const orderBy = requestParameters.orderBy;
        const order = requestParameters.order;
        const limit = requestParameters.limit;
        const page = requestParameters.page;
        const accountId = requestParameters.accountId;
        const userId = requestParameters.userId;
        const membershipId = requestParameters.membershipId;
        const eventType = requestParameters.eventType;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (createdByUsername) {
            createdByUsername.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'createdByUsername');
            })
        }
        if (createdByUserId) {
            createdByUserId.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'createdByUserId');
            })
        }
        if (fromDate !== undefined && fromDate !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>fromDate, 'fromDate');
        }
        if (toDate !== undefined && toDate !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>toDate, 'toDate');
        }
        if (orderBy !== undefined && orderBy !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>orderBy, 'orderBy');
        }
        if (order !== undefined && order !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>order, 'order');
        }
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (accountId !== undefined && accountId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>accountId, 'accountId');
        }
        if (userId !== undefined && userId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>userId, 'userId');
        }
        if (membershipId !== undefined && membershipId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>membershipId, 'membershipId');
        }
        if (eventType) {
            eventType.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'eventType');
            })
        }

        let headers = this.defaultHeaders;
        if (program !== undefined && program !== null) {
            headers = headers.set('program', String(program));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<AccountUserEventResponse>(`${this.configuration.basePath}/event-service/events/account-user`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List normalized account events
     * Returns the same account, membership and user event history as the older account-user endpoint, but with a unified shape: eventType is always populated, and subject always carries membershipId or userId for the event types that imply one. At least one of accountId, userId or membershipId must be supplied. Ordering is fixed to createdAt descending with _id as tie-breaker so that paging is stable; the orderBy and order parameters are accepted but not applied here.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listNormalizedEvents(requestParameters: ListNormalizedEventsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<NormalizedAccountEventDtoResponse>;
    public listNormalizedEvents(requestParameters: ListNormalizedEventsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<NormalizedAccountEventDtoResponse>>;
    public listNormalizedEvents(requestParameters: ListNormalizedEventsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<NormalizedAccountEventDtoResponse>>;
    public listNormalizedEvents(requestParameters: ListNormalizedEventsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const program = requestParameters.program;
        if (program === null || program === undefined) {
            throw new Error('Required parameter program was null or undefined when calling listNormalizedEvents.');
        }
        const createdByUsername = requestParameters.createdByUsername;
        const createdByUserId = requestParameters.createdByUserId;
        const fromDate = requestParameters.fromDate;
        const toDate = requestParameters.toDate;
        const orderBy = requestParameters.orderBy;
        const order = requestParameters.order;
        const limit = requestParameters.limit;
        const page = requestParameters.page;
        const accountId = requestParameters.accountId;
        const userId = requestParameters.userId;
        const membershipId = requestParameters.membershipId;
        const eventType = requestParameters.eventType;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (createdByUsername) {
            createdByUsername.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'createdByUsername');
            })
        }
        if (createdByUserId) {
            createdByUserId.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'createdByUserId');
            })
        }
        if (fromDate !== undefined && fromDate !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>fromDate, 'fromDate');
        }
        if (toDate !== undefined && toDate !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>toDate, 'toDate');
        }
        if (orderBy !== undefined && orderBy !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>orderBy, 'orderBy');
        }
        if (order !== undefined && order !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>order, 'order');
        }
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (accountId !== undefined && accountId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>accountId, 'accountId');
        }
        if (userId !== undefined && userId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>userId, 'userId');
        }
        if (membershipId !== undefined && membershipId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>membershipId, 'membershipId');
        }
        if (eventType) {
            eventType.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'eventType');
            })
        }

        let headers = this.defaultHeaders;
        if (program !== undefined && program !== null) {
            headers = headers.set('program', String(program));
        }

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<NormalizedAccountEventDtoResponse>(`${this.configuration.basePath}/event-service/v2/events/account-user`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
